<template>
  <belongs-to-relation-field :value="getMediaValue()" show-id="false"></belongs-to-relation-field>
</template>

<script>
import BelongsToRelationField from '@kanrisha/components/Presentation/BelongsToRelationField';

export default {
  components: {
    BelongsToRelationField,
  },
  props: {
    action: { type: String, default: 'changed' },
    value: { type: Object, default: () => {} },
  },
  setup(props) {
    const getMediaValue = () => {
      let mediaValue = props.value;
      switch (props.action) {
        case 'added':
          mediaValue.color = '#00A000';
          mediaValue.iconClass = 'bi bi-file-earmark-plus';
          break;
        case 'removed':
          mediaValue.color = '#A00000';
          mediaValue.iconClass = 'bi bi-trash';
          break;
        default:
      }

      return mediaValue;
    };

    return {
      getMediaValue,
    };
  },
};
</script>
